// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import graniteAPIClient from 'granite-admin/utils/granite-client';

// Application Imports
import EmployeeEntity from 'granite-admin/organisations/entities/employee';
import { env } from 'granite-admin/env';
const url = env.REACT_APP_ORGANISATION_BASE_URL || process.env.REACT_APP_ORGANISATION_BASE_URL;
async function getEmployees(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await graniteAPIClient(url).get('/employees/', payload);
    if (!params?.export) {
      const list = data ? data.results.map(item => new EmployeeEntity({
        mapValues: true,
        ...item.user,
        ...item
      })) : [];
      return {
        list,
        count: data.count
      };
    } else {
      return data;
    }
  } catch (error) {
    console.log(error);
    const errorMessage = error?.response?.data?.message;
    throw new GraniteError(errorMessage);
  }
}
async function getEmployee(id) {
  try {
    if (id === 'add') return {
      role: ''
    };
    const {
      data
    } = await graniteAPIClient(url).get(`/employees/${id}/`);
    if (data) {
      return new EmployeeEntity({
        mapValues: true,
        ...data.user,
        ...data
      });
    }
    return {};
  } catch (error) {
    console.log(error);
    const errorMessage = error.response.data.message;
    throw new GraniteError(errorMessage);
  }
}

// async function addEmployee(organisation, employee) {
//   try {
//     const payload = new EmployeeEntity(employee).mapToSnakeCase()
//     const response = await graniteAPIClient(url, {organisation}).post(
//       '/employee/',
//       payload,
//     )
//     return response
//   } catch (error) {
//     console.log(error)
//     const errorMessage = error.response.data.message
//     throw new GraniteError(errorMessage)
//   }
// }

async function updateEmployee(employee) {
  const payload = new EmployeeEntity({
    mapValues: true,
    ...employee
  }).mapToSnakeCase();
  if (employee.pk) {
    let {
      data
    } = await graniteAPIClient(url).put(`/employees/${employee.pk}/`, payload);
    return new EmployeeEntity({
      mapValues: true,
      ...data.user,
      ...data
    });
  } else {
    let {
      data
    } = await graniteAPIClient(url).post('/employees/', payload);
    return new EmployeeEntity({
      mapValues: true,
      ...data.user,
      ...data
    });
  }
}
async function deleteEmployee(employeeId) {
  try {
    const response = await graniteAPIClient(url).delete(`/employees/${employeeId}/`);
    return response;
  } catch (error) {
    console.log(error);
    const errorMessage = error.response.data.message;
    throw new GraniteError(errorMessage);
  }
}
async function deleteEmployeeBulk(organisation, employeeIdArray) {
  try {
    // const response = await graniteAPIClient(url, {organisation}).delete(
    //   `/employees-bulk/${employeeId}/`,
    // )
    console.log(organisation, employeeIdArray);
    return true;
  } catch (error) {
    console.log(error);
    const errorMessage = error.response.data.message;
    throw new GraniteError(errorMessage);
  }
}
async function updateEmployeeStatus(employee_ids, is_active) {
  try {
    const payload = {
      employee_ids,
      is_active
    };
    const response = await graniteAPIClient().post('employee/bulk/active/', payload);
    return response;
  } catch (error) {
    const errorMessage = error.response.data.message;
    throw new GraniteError(errorMessage);
  }
}
async function getRoles(params) {
  try {
    const {
      data
    } = await graniteAPIClient(url).get('/organisation/roles/', {
      params
    });
    return data.results;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function exportEmployees() {
  try {
    const response = await graniteAPIClient(url).get('/employees/?export=csv&sync=no');
    function download_csv() {
      var csv = response.data;
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'employees.csv';
      hiddenElement.click();
    }
    download_csv();
    return response;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function getBusinessAdminRoles(params) {
  try {
    const {
      data
    } = await graniteAPIClient(url).get('/business-admin/roles/', {
      params
    });
    return data.results;
  } catch (error) {
    throw new GraniteError(error);
  }
}
export default {
  deleteEmployee,
  deleteEmployeeBulk,
  getEmployees,
  getEmployee,
  updateEmployee,
  updateEmployeeStatus,
  getRoles,
  exportEmployees,
  getBusinessAdminRoles
};